import React from 'react';
import Button from '../../../../../components/Button';
import Anchor from '../../../../../components/link/Anchor';
import { CS_REVIEW_DETAIL_URL_PATH } from '../../../../../constants/service/common/urlConstants';
import ColumnInputFilter from '../../../../../components/table/ReactTableColumnFilter';
import SelectColumnFilter from '../../../../../components/table/SelectColumnFilter';
import OpenProductDetail from '../../../../../components/link/OpenProductDetail';
import OpenPreviewProductDetail from '../../../../app/common/OpenPreviewProductDetail';
import OpenBrandDetail from '../../../../../components/link/OpenBrandDetail';
import OpenOrderItemDetail from '../../../../../components/link/OpenOrderItemDetail';
import OpenUserDetail from '../../../../../components/link/OpenUserDetail';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import { setDateFormat } from '../../../../../lib/moment';
import { openNewWindow, reDirectPage, setDetailPageUrl } from '../../../../../lib/common';
import {
  CS_IS_REPORTED_REVIEW_SELECT_LIST,
  CS_GENERAL_REVIEW,
  CS_REPORTED_REVIEW,
  CS_REVIEW_ATTACHMENT_EXISTS_SELECT_LIST,
  CS_REVIEW_ATTACHMENT_EXISTS_TEXT,
  CS_REVIEW_RATE_SELECT_LIST,
  CS_REVIEW_STATUS_SELECT_LIST,
  REVIEW_STATUS_TEXT,
} from '../../../../../constants/service/app/csReviewConstants';
import { DateRangePickerStyled } from './CsReview.style';

/**
 *  상품 후기 리스트 컬럼
 */
const csReviewListColumns = ({ onChangeFilterOption, onClickDateRangeChange, handleProductPreviewModal }) => {
  return [
    {
      Header: '상세보기',
      disableSortBy: true,
      Cell: (row) => (
        <Button
          isRadius
          color="primary"
          text="상세보기"
          onClick={() => reDirectPage({ path: setDetailPageUrl(CS_REVIEW_DETAIL_URL_PATH, row.row.original.id) })}
        />
      ),
    },
    {
      accessor: 'id',
      Header: '상품 후기 ID',
      filterable: true,
      disableSortBy: true,
      Cell: (row) => (
        <Anchor
          isUnderLine
          color="primary"
          text={row.value}
          onClick={() => openNewWindow(setDetailPageUrl(CS_REVIEW_DETAIL_URL_PATH, row.value))}
        />
      ),
      Filter: ({ column }) => <ColumnInputFilter onChange={onChangeFilterOption} option={column} />,
    },
    {
      accessor: 'status',
      Header: '상태',
      filterable: true,
      disableSortBy: true,
      Cell: (row) => REVIEW_STATUS_TEXT[row.value] || '-',
      Filter: ({ column }) => (
        <SelectColumnFilter list={CS_REVIEW_STATUS_SELECT_LIST} column={column} onChange={onChangeFilterOption} />
      ),
    },
    {
      accessor: 'isReported',
      Header: '신고 여부',
      filterable: true,
      disableSortBy: true,
      Cell: (row) => (row.value ? CS_REPORTED_REVIEW : CS_GENERAL_REVIEW),
      Filter: ({ column }) => (
        <SelectColumnFilter list={CS_IS_REPORTED_REVIEW_SELECT_LIST} column={column} onChange={onChangeFilterOption} />
      ),
    },
    {
      accessor: 'rate',
      Header: '별점',
      sortable: true,
      filterable: true,
      Filter: ({ column }) => (
        <SelectColumnFilter list={CS_REVIEW_RATE_SELECT_LIST} column={column} onChange={onChangeFilterOption} />
      ),
    },
    {
      accessor: 'hasAttachments',
      Header: '첨부파일',
      filterable: true,
      disableSortBy: true,
      Cell: (row) => CS_REVIEW_ATTACHMENT_EXISTS_TEXT[row.value] || '-',
      Filter: ({ column }) => (
        <SelectColumnFilter
          list={CS_REVIEW_ATTACHMENT_EXISTS_SELECT_LIST}
          column={column}
          onChange={onChangeFilterOption}
        />
      ),
    },
    {
      accessor: (row) => row.product.id,
      id: 'productId',
      Header: '상품번호(AMONDZ)',
      filterable: true,
      disableSortBy: true,
      Cell: (row) => <OpenProductDetail text={row.value} productId={row.value} />,
      Filter: ({ column }) => <ColumnInputFilter onChange={onChangeFilterOption} option={column} />,
    },
    {
      accessor: (row) => row.product.name,
      id: 'productName',
      Header: '상품명',
      filterable: true,
      disableSortBy: true,
      Cell: (row) => {
        return (
          <OpenPreviewProductDetail
            text={row.value}
            productId={row.row.original.product.id}
            getProductPreviewData={handleProductPreviewModal}
          />
        );
      },
      Filter: ({ column }) => <ColumnInputFilter onChange={onChangeFilterOption} option={column} />,
    },
    {
      accessor: (row) => row.store.name,
      id: 'storeName',
      Header: '상점명',
      filterable: true,
      disableSortBy: true,
      Cell: (row) => <OpenBrandDetail text={row.value} storeId={row.row.original.store.id} />,
      Filter: ({ column }) => <ColumnInputFilter onChange={onChangeFilterOption} option={column} />,
    },
    {
      accessor: (row) => row.store.id,
      id: 'storeId',
      Header: '브랜드 ID',
      filterable: true,
      disableSortBy: true,
      Cell: (row) => <OpenBrandDetail text={row.value} storeId={row.value} />,
      Filter: ({ column }) => <ColumnInputFilter onChange={onChangeFilterOption} option={column} />,
    },
    {
      accessor: 'orderItemId',
      Header: '상품 주문번호',
      filterable: true,
      disableSortBy: true,
      Cell: (row) => <OpenOrderItemDetail text={row.value} orderItemId={row.value} />,
      Filter: ({ column }) => <ColumnInputFilter onChange={onChangeFilterOption} option={column} />,
    },
    {
      accessor: (row) => row.user.id,
      id: 'userId',
      Header: '작성자 ID',
      filterable: true,
      disableSortBy: true,
      Cell: (row) => <OpenUserDetail text={row.value} userId={row.value} />,
      Filter: ({ column }) => <ColumnInputFilter onChange={onChangeFilterOption} option={column} />,
    },
    {
      accessor: (row) => row.user.name,
      id: 'userName',
      Header: '작성자명',
      filterable: true,
      disableSortBy: true,
      Filter: ({ column }) => <ColumnInputFilter onChange={onChangeFilterOption} option={column} />,
    },
    {
      accessor: 'content',
      Header: '구매평',
      resizable: true,
      filterable: true,
      disableSortBy: true,
      Filter: ({ column }) => <ColumnInputFilter onChange={onChangeFilterOption} option={column} />,
    },
    {
      accessor: 'createDate',
      Header: '작성일',
      sortable: true,
      filterable: true,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_DASH_FORMAT),
      Filter: ({ column }) => {
        return (
          <DateRangePickerStyled
            value={{
              startDate: column.filterValue ? column.filterValue.createStartDate : null,
              endDate: column.filterValue ? column.filterValue.createEndDate : null,
            }}
            outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
            onSelect={onClickDateRangeChange}
          />
        );
      },
    },
  ];
};

export default csReviewListColumns;
